import { useFormik } from "formik";
import * as Yup from "yup";
import { useEffect, useState } from "react";
import Select from "../../../form/select/Select";
import { updateCorporateCustomerBusinessInfo } from "../../../../redux/slice/customer/customerSlice";
import { useDispatch, useSelector } from "react-redux";
import moment from "moment";
import { useSignature } from "../../../../utils/hooks/useSignature";
import { FcCheckmark } from "react-icons/fc";
import { flashMessage } from "../../../../utils/flash";

const targetType = [
  { id: "Employees", name: "Employees" },
  { id: "Customers", name: "Customers" },
];
const BusinessInformation = ({ data, data1 }) => {
  const [editing, setEditing] = useState(false);
  const [editCustomer, setEditCustomer] = useState();

  const { user_permissions } = useSelector((state) => state?.auth?.user);

  const dispatch = useDispatch();
  const {
    value: sign,
    Signature,
    clearSignature,
    saveSignature,
  } = useSignature(220, 100);

  const onSubmit = (values) => {
    let payload = { ...values, id: data.id, customer_signature: sign };
    dispatch(updateCorporateCustomerBusinessInfo(payload));
  };

  const handleClose = () => {
    values.business_name = data1?.business_name;
    values.business_type = data1?.business_type;
    values.number_of_customer = data1?.number_of_customer;
    values.target_category = data1?.target_category;
  };

  const validationScehma = Yup.object().shape({
    business_name: Yup.string("Business name must be a string").required(
      "Business name cannot be blank"
    ),
    business_type: Yup.string("First Name must be a string").required(
      "Business type cannot be blank"
    ),
    number_of_customer: Yup.string(
      "Number of customers must be a string"
    ).required("Number of customers cannot be blank"),
    target_category: Yup.string("Target category must be a string").required(
      "Target category cannot be blank"
    ),
  });
  const {
    values,
    errors,
    touched,
    handleBlur,
    handleChange,
    handleSubmit,
    setFieldValue,
  } = useFormik({
    enableReinitialize: true,
    initialValues: {
      business_name: data1?.business_name || "",
      business_type: data1?.business_type || "",
      number_of_customer: data1?.number_of_customer || "",
      target_category: data1?.target_category || "",
    },
    validationSchema: validationScehma,
    onSubmit,
  });

  const targetData = targetType?.map((state) => {
    return {
      label: state.name,
      value: state.id,
    };
  });

  useEffect(() => {
    setEditCustomer(
      user_permissions?.some(
        (permission) => permission.name === "edit customer - corporate"
      )
    );
  }, [user_permissions]);
  return (
    <>
      <form
        className='border p-3 rounded-3 mt-4 position-relative'
        onSubmit={handleSubmit}
      >
        <h4 className='fw-semibold text-primary-1 bg-white position-absolute profile-title'>
          Business Information
        </h4>
        <div className='row'>
          <div className='col-md-12'>
            <div className='row mb-3'>
              <div className='col-md-6'>
                <div className='row'>
                  <div className='col-sm-6 col-md-6'>
                    <label htmlFor='firstName ' className='fw-bold pb-1'>
                      BUSINESS NAME
                    </label>
                    {!editing ? (
                      <p className='text-capitalize'>{values.business_name}</p>
                    ) : (
                      <div>
                        <input
                          className='form-control form-control-sm'
                          id='business_name'
                          value={values.business_name}
                          type='text'
                          onChange={handleChange}
                          onBlur={handleBlur}
                        />
                        {errors?.business_name && touched?.business_name && (
                          <p className='mb-0 text-danger'>
                            {errors?.business_name + "*"}
                          </p>
                        )}
                      </div>
                    )}
                  </div>
                  <div className='col-sm-6 col-md-6'>
                    <label htmlFor='lastname' className='fw-bold pb-1'>
                      BUSINESS TYPE
                    </label>
                    {!editing ? (
                      <p>{values.business_type}</p>
                    ) : (
                      <div>
                        <input
                          className='form-control form-control-sm'
                          id='business_type'
                          value={values.business_type}
                          type='text'
                          onChange={handleChange}
                          onBlur={handleBlur}
                        />
                        {errors?.business_type && touched?.business_type && (
                          <p className='mb-0 text-danger'>
                            {errors?.business_type + "*"}
                          </p>
                        )}
                      </div>
                    )}
                  </div>
                </div>
              </div>
              <div className='col-md-6'>
                <div className='row'>
                  <div className='col-sm-6 col-md-6'>
                    <label htmlFor='middlename' className='fw-bold pb-1'>
                      NO. OF CUSTOMERS
                    </label>
                    {!editing ? (
                      <p>{values.number_of_customer}</p>
                    ) : (
                      <div>
                        <input
                          className='form-control form-control-sm'
                          type={"number"}
                          name='number_of_customer'
                          onChange={handleChange}
                          onBlur={handleBlur}
                          value={values?.number_of_customer}
                        />
                        {errors?.number_of_customer &&
                          touched?.number_of_customer && (
                            <p className='mb-0 text-danger'>
                              {errors?.number_of_customer + "*"}
                            </p>
                          )}
                      </div>
                    )}
                  </div>
                  <div className='col-sm-6 col-md-6'>
                    <label htmlFor='middlename' className='fw-bold pb-1'>
                      TARGET CATEGORY
                    </label>
                    {!editing ? (
                      <p>{values.target_category}</p>
                    ) : (
                      <div>
                        <Select
                          onBlur={() => {
                            handleBlur({ target: { name: "target_category" } });
                          }}
                          name='target_category'
                          data={targetData}
                          value={values.target_category}
                          onChange={(selectedOption) =>
                            setFieldValue(
                              "target_category",
                              selectedOption?.value
                            )
                          }
                        />
                        {errors?.target_category &&
                          touched?.target_category && (
                            <p className='mb-0 text-danger'>
                              {errors?.target_category + "*"}
                            </p>
                          )}
                      </div>
                    )}
                  </div>
                </div>
              </div>
            </div>
            <div className='row mb-2'>
              <div className='col-md-6'>
                <div className='row'>
                  <div className='col-md-6'>
                    <label className='text-primary-1 fw-bold pb-1'>
                      Customer Id
                    </label>
                    <p>{data?.customer_id}</p>
                  </div>
                  <div className='col-md-6'>
                    <label className='text-primary-1 fw-bold pb-1'>
                      Office{" "}
                    </label>
                    <p className='text-capitalize'>{data?.office_name}</p>
                  </div>
                </div>
              </div>
              <div className='col-md-6'>
                <div className='row'>
                  <div className='col-md-6'>
                    <label className='text-primary-1 fw-bold pb-1'>Agent</label>
                    <p>{data?.user_first_name + " " + data?.user_last_name}</p>
                  </div>
                  <div
                    className={`col-sm-6 col-md-6 ${
                      data?.status === "0" && "d-none"
                    }`}
                  >
                    <label className='text-primary-1 fw-bold pb-1'>
                      {data?.status === "1" && "Acceptance Date"}
                      {data?.status === "2" && "Rejection Date"}
                      {data?.status === "3" && "Close Date"}
                    </label>
                    <p className='text-capitalize'>
                      {data?.status === "1" &&
                        moment(`${data?.approve_date}`).format("L")}
                      {data?.status === "2" &&
                        moment(`${data?.reject_date}`).format("L")}
                      {data?.status === "3" &&
                        moment(`${data?.close_date}`).format("L")}
                    </p>
                  </div>
                </div>
              </div>
            </div>
            <div className='row mb-2'>
              {data?.status === "2" && (
                <div className='col-md-3'>
                  <label className='text-primary-1 fw-bold pb-1'>
                    Rejection Reason
                  </label>
                  <p>{data?.status_reason}</p>
                </div>
              )}

              <div className='col-md-3'>
                <div className='d-flex flex-column '>
                  <label
                    htmlFor='firstName '
                    className='text-primary-1 fw-bold pb-1'
                  >
                    Customer Signature
                  </label>
                  {data1?.customer_signature && !editing ? (
                    <img
                      src={data1?.customer_signature}
                      alt='signature'
                      width={80}
                      height={50}
                      className='mt-2'
                    />
                  ) : (
                    !editing && <span className='mt-2 me-3'>Nill</span>
                  )}
                </div>
                {editing ? (
                  <div className='d-flex flex-column'>
                    {Signature}
                    <div>
                      <button
                        type='button'
                        className='btn btn-sm btn-secondary mt-2'
                        onClick={() => clearSignature()}
                      >
                        Clear
                      </button>
                      <button
                        type='button'
                        className='btn btn-sm btn-primary mt-2 mx-2'
                        onClick={() => saveSignature()}
                      >
                        commit
                      </button>
                      {sign && (
                        <span className='ml-2'>
                          <FcCheckmark size={22} />
                        </span>
                      )}
                    </div>
                  </div>
                ) : null}
              </div>
            </div>
          </div>
        </div>
        <div className='row mt-1'>
          <div className='col-md-12'>
            <div className='d-flex justify-content-between align-content-center'>
              <div className='d-flex justify-content-center align-content-center gap-2'>
                <h5>Status:</h5>
                <p
                  className={`badge ${
                    data?.status === "1" && "badge-warning-lighten"
                  } ${data?.status === "2" && "badge-success-lighten"} ${
                    data?.status === "3" && "badge-danger-lighten"
                  } ${
                    data?.status === "4" && "badge-secondary-lighten"
                  } fw-normal rounded-4 mt-1`}
                  style={{
                    fontSize: "12px",
                    padding: "5px 10px",
                  }}
                >
                  {data?.status === "1" && "Pending Approval"}
                  {data?.status === "2" && "Active"}
                  {data?.status === "3" && "Rejected"}
                  {data?.status === "4" && "Closed"}
                </p>
              </div>
              {editCustomer && data?.status !== "3" && (
                <div className='d-flex justify-content-end'>
                  <div>
                    <button
                      type='button'
                      className={`btn btn-${
                        editing ? "warning" : "info"
                      } btn-sm px-4 text-white`}
                      onClick={() => {
                        setEditing(editing ? false : true);
                        handleClose();
                        clearSignature();
                      }}
                    >
                      {editing ? "Close" : "Edit"}
                    </button>
                    {editing && (
                      <button
                        className='btn btn-success ms-2 btn-sm px-4'
                        type='submit'
                      >
                        Save
                      </button>
                    )}
                  </div>
                </div>
              )}
            </div>
          </div>
        </div>
      </form>
    </>
  );
};

export default BusinessInformation;
